import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { EmptyStateGuideInfo } from './emptyStateGuideInfo';
import {
  faFolderGrid,
  faPlus,
  faStar,
  faUsers,
} from '@fortawesome/pro-regular-svg-icons';
import { InitialSubscriptionPriceModal } from './InitialSubscriptionPriceModal';
import { ExclusivePriceSetupProps } from '@client/new/common/selfServeExclusive/exclusivePriceSetup';
import SubEmptyStateImg from './subscription-empty-state.png';
import { EmptyStateCard } from './EmptyStateCard';

export type SubscriptionEmptyStateProps = {
  name: string;
  guideLink: string;
  create: () => void;
  modal: {
    isOpen: boolean;
    onClose: () => void;
    createProgram: () => void;
    savePricing: (callback?: () => void) => void;
    exclusive: ExclusivePriceSetupProps;
    errors?: string[];
  };
};

const options = [
  {
    icon: faStar,
    title: 'Exclusive access',
    details: [
      'Charge monthly and/or annual for access to your content.',
      'No one else can access your content or community.',
    ],
  },
  {
    icon: faFolderGrid,
    title: 'Create a content library that your audience loves',
    details:
      'Build a library of programs, categories, tutorials, nutrition, etc so your subscribers have everything they need to be successful!',
  },
  {
    icon: faUsers,
    title: 'Ongoing content & community',
    details:
      'To help keep customer subscribed, engage with them through community tools and let them know when new content is coming!',
  },
];

export const SubscriptionEmptyState = ({
  name,
  guideLink,
  create,
  modal,
}: SubscriptionEmptyStateProps) => (
  <div className="w-full h-full flex flex-col gap-8 items-center">
    <EmptyStateGuideInfo
      name={name}
      type="Subscription"
      guideLink={guideLink}
    />

    <div className="p-6 w-full h-max bg-white rounded-[10px] flex justify-between flex-col md:flex-row gap-12 md:gap-2">
      <div className="w-full h-max flex flex-col gap-6">
        <Typography variant="headline" size="small">
          Start setting up your first Subscription product
        </Typography>
        <EmptyStateCard options={options} />
        <Button
          color="neutral"
          className="w-[180px]"
          leftIcon={faPlus}
          onClick={create}
        >
          Create
        </Button>
        <InitialSubscriptionPriceModal {...modal} />
      </div>
      <img
        src={SubEmptyStateImg}
        className="w-full md:w-[50%] max-h-[300px] object-contain self-center"
      />
    </div>
  </div>
);
